<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/ch1">A Buried Alive Sensation</a></p>
<p class="toc"><span href="#/ch2" title="Link target outside of Sample">The Lynching of Eugene Hairston</span></p>
<p class="toc"><span href="#/ch3" title="Link target outside of Sample">The Affront that Turned Deadly</span></p>
<p class="toc"><span href="#/ch4" title="Link target outside of Sample">A Deadly Shootout with Revenue Officers</span></p>
<p class="toc"><span href="#/ch5" title="Link target outside of Sample">The Carmichael Murder and Suicide</span></p>
<p class="toc"><span href="#/ch6" title="Link target outside of Sample">Ade Walker: “A Bad Man and Dangerous Character”</span></p>
<p class="toc"><span href="#/ch7" title="Link target outside of Sample">Stray Curs with Fancy Pedigrees</span></p>
<p class="toc"><span href="#/ch8" title="Link target outside of Sample">A Mysterious Explosion at the Town Hall</span></p>
<p class="toc"><span href="#/ch9" title="Link target outside of Sample">The Great Bank Robbery</span></p>
<p class="toc"><span href="#/ch10" title="Link target outside of Sample">Yeggmen and the Town Post Office</span></p>
<p class="toc"><span href="#/ch11" title="Link target outside of Sample">The Rider Who Shot Conductor Holden</span></p>
<p class="toc"><span href="#/ch12" title="Link target outside of Sample">A Little Child Shall Lead Them</span></p>
<p class="toc"><span href="#/ch13" title="Link target outside of Sample">The Queen of Virginia Bootleggers</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0afcbe87